import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { useTheme } from '../../contexts/ThemeContext';
import {
  startCard,
  startPrimaryButton,
  startSecondaryButton,
  startInput
} from './startPageTokens';

const StartQuestionModal = ({
  isOpen,
  onClose,
  onSubmit,
  questionText,
  setQuestionText,
  assigneeName,
  loading = false,
  submitting = false
}) => {
  const { darkMode } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className={`${startCard} max-w-md w-full max-h-[90vh] overflow-y-auto`}>
        <div className="relative p-5 pb-0">
          <h2
            className={`text-lg font-semibold text-center pr-8 ${
              darkMode ? 'text-white' : 'text-gray-800'
            }`}
          >
            Ask a Question
          </h2>
          {assigneeName ? (
            <p
              className={`text-sm text-center mt-2 pr-8 ${
                darkMode ? 'text-gray-400' : 'text-gray-600'
              }`}
            >
              Sent to your Success Manager:{' '}
              <span className="font-medium">{assigneeName}</span>
            </p>
          ) : null}
          <button
            type="button"
            onClick={onClose}
            className="absolute top-5 right-5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            aria-label="Close"
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>
        <div className="p-5">
          {loading ? (
            <div className="flex items-center justify-center py-8">
              <div className="animate-spin rounded-full h-7 w-7 border-b-2 border-red-600" />
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-4">
              <textarea
                id="start-questionText"
                value={questionText}
                onChange={(e) => setQuestionText(e.target.value)}
                className={startInput}
                rows="4"
                placeholder="Type your question here..."
                required
                aria-label="Your question"
              />
              <div className="flex justify-end gap-2 pt-2">
                <button type="button" onClick={onClose} className={startSecondaryButton}>
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={submitting}
                  className={`${startPrimaryButton} ${
                    submitting ? 'opacity-60 cursor-not-allowed' : ''
                  }`}
                >
                  {submitting ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default StartQuestionModal;
